module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	'use strict';

	fox.registerWidget('Member', {
		rendering: function() {
			var pm = this.wom1('@root .PermissionManager');

			if (pm) {
				if (pm.member) return this.callParent('rendering', arguments);

				return this.createFragment();
			}

			if (fox.isEmpty(fox.site.member)) {
				return this.createFragment();
			}

			return this.callParent('rendering', arguments);
		}
	});
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/main/widget/member.js
// module id = 125
// module chunks = 4